const feedbacksLogopedOnlineArr = [
    {
        name: 'Елена Жамкова',
        data: '24 июня 2025',
        description: `Вероника Владимировна, помогла сыну справиться с дислексией и дисграфией. Ребёнок научился
        выражать свои мысли. Благодаря занятиям с Вероникой Владимировной сдал экзамен по русскому
        языку устно и письменно. Молодой, грамотный педагог умеющий находить подход и
        заинтересовывать ученика занятиями.`,
        source: 'Яндекс'
    },
    {
        name: 'Татьяна С.',
        data: '25 июня 2025',
        description: `Прекрасный специалист!
        Занималась с ребенком. В обозначенные сроки поставили все звуки. Не смотря на он-лайн
        занятия, всегда могла заинтересовать и привлечь внимание ребенка.
        Также очень внимательна к просьбам родителей, помогает решать дополнительные вопросы,
        возникшие в процессе обучения.
        Еще раз большое спасибо за проделанную работу`,
        source: 'Яндекс'
    },
    {
        name: 'Алёна З.',
        data: '29 июня 2025',
        description: `Вероника - хороший специалист! Ставили Р и Л дочери 6 лет, на мой взгляд, очень быстро справились с задачей👍 Вероника очень организованный преподователь, внимательна
        и терпелива к ребёнку, дочь с удовольствием занималась) смело буду рекомендовать друзьям и
        знакомым!`,
        source: 'Яндекс'
    },
    {
        name: 'Ravil Galimzyanov',
        data: '2025',
        description: `Спасибо, Вероника за Вашу хорошую профессиональную работу. Равиль Махмудович и Наталья.`,
        source: 'Google'
    },
    {
        name: 'Andrey Stolyarchuk',
        data: '2025',
        description: `Отличный результат, ребёнок стал намного лучше говорить, поставлены все недостающие звуки`,
        source: 'Google'
    },

];

export default feedbacksLogopedOnlineArr;